var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.overlay,"opacity":_vm.opacity,"z-index":"210"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","color":"primary"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }